

// 4) HandwrittenLabel.tsx (new, plain text — no badge)
// Path: packages/components/src/homepage/hero/HandwrittenLabel.tsx

import React from 'react';
import clsx from 'clsx';

const fontStack =
  "'Caveat', 'Patrick Hand', 'Comic Sans MS', 'ui-serif', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif";

const HandwrittenLabel: React.FC<{
  text: string;
  className?: string;
  angleDeg?: number;
  color?: string;
  sizePx?: number;
}> = ({ text, className, angleDeg = -6, color = '#0f172a', sizePx = 18 }) => {
  return (
    <div
      className={clsx('absolute z-20 pointer-events-none select-none', className)}
      style={{
        transform: `rotate(${angleDeg}deg)`,
        color,
        fontFamily: fontStack,
        fontWeight: 800,
        fontSize: sizePx,
        letterSpacing: 0.4,
        textShadow: '0.5px 0.5px 0 rgba(0,0,0,0.15)',
      }}
    >
      {text}
    </div>
  );
};

export default HandwrittenLabel;